import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import DashboardFilter from './_dashboardFilter';
import MonthYearFilterModal from './_monthyearfilter';
import { useGetRentSummaryDashboardQuery, useGetLandlordDefaultersQuery, useGetRentPaidProgressQuery, useGetLandlordPropertyQuery, useGetRentExpenseSummaryQuery } from '../../lib/apiSlice/property/propertySlice.tsx';
import DashboardMetrics from './_cardmetrics.jsx';
import ProgressCircle from './_progressCard.jsx';
import PropertiesTable from './_propertyTable.jsx';
import GraphYearly from './_graphyearly.jsx';

const DashboardPage = () => {
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [landlordPercentagePaid, setLandlordPercentagePaid] = useState(0);



  const [currentFilter, setCurrentFilter] = useState({
    month: new Date().toLocaleString('default', { month: 'long' }).toLowerCase(),
    year: new Date().getFullYear()
  });

  // get the properties data from the redux store
  const { data: properties, isLoading: propertiesLoading } = useGetLandlordPropertyQuery()

  // get the rent summary data from the redux store
  const { data: rentExpenseSummary, isLoading: rentExpenseLoading } = useGetRentExpenseSummaryQuery({
    year: currentFilter.year,
  });



  // pass the data for the dashboard metrics
  const { data: dashboardData, isLoading } = useGetRentSummaryDashboardQuery({
    month: currentFilter.month,
    year: currentFilter.year,
  });


  const { data: defaultersData } = useGetLandlordDefaultersQuery()
  const { data: rentProgres } = useGetRentPaidProgressQuery()

  const handleFilterApply = (month, year) => {
    // Here you would typically refetch data with the new filter
    console.log('Applying filter:', { month, year });
  };

  return (
    <div className="flex flex-col gap-4 px-4">
      <Helmet>
        <title>Dashboard</title>
        <meta name="description" content="Admin dashboard page" />
      </Helmet>

      <DashboardFilter
        onFilterClick={() => setIsFilterModalOpen(true)}
        currentFilter={currentFilter}
      />

      {/* dashboard metrics */}
      <DashboardMetrics dataMetrics={dashboardData} defaulters={defaultersData} />

      {/* pogrees and table */}
      <div className="gap-4 grid grid-cols-1 lg:grid-cols-4 mt-4">
        {/* Progress Circle Card - takes 1 column on mobile, 1 on lg screens */}
        <div className="lg:col-span-1">
          <ProgressCircle percentage={dashboardData ? dashboardData.percentage_paid : 0} />
        </div>

        {/* Properties Table - takes 1 column on mobile, 3 on lg screens */}
        <div className="lg:col-span-3">
          <PropertiesTable
            isLoading={propertiesLoading}
            properties={dashboardData?.apartment_details}
          // displayedItems={displayedItems}
          // currentPage={currentPage}
          // totalPages={totalPages}
          // handlePrevPage={handlePrevPage}
          // handleNextPage={handleNextPage}
          // handleReminderModalOpen={handleReminderModalOpen}
          // getPropertyImage={getPropertyImage}
          // getPercentageBadgeClass={getPercentageBadgeClass}
          // subscriptionStatus={subscriptionStatus}
          // subscription={subscription}
          />
        </div>
      </div>

      {/* the graph display */}
      <div className='bg-white shadow-lg mt-4 mb-2 p-1 rounded-lg'>
        <GraphYearly data={rentExpenseSummary}  dataMetrics={dashboardData}/>
      </div>

      <MonthYearFilterModal
        isOpen={isFilterModalOpen}
        onClose={() => setIsFilterModalOpen(false)}
        onApply={handleFilterApply}
        currentFilter={currentFilter}
        setCurrentFilter={setCurrentFilter}
      />
    </div>
  );
};

// Helper function to capitalize first letter
function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export default DashboardPage;